<form class="mc-spring-board" (ngSubmit)="onSubmit()" [formGroup]="taskFilterForm">
  <mat-toolbar class="mc-spring-board-header" color="secondary">
    Filters
    <span class="mc-fill-remaining-flex-space"></span>
    <button type="button" mat-icon-button color="secondary-invert" tabindex="-1" (click)="closeDialog()">
      <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
    </button>
  </mat-toolbar>
  <div class="mc-spring-board-form-body">
    <h4 class="mc-form-heading">Custom Dates</h4>
    <div class="mc-form-fields-row">
      <mat-form-field mcColor="secondary" class="mc-form-field">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="startPicker" placeholder="Start Date" formControlName="startDate">
        <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker color="secondary" #startPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field mcColor="secondary" class="mc-form-field">
        <mat-label>Start Time</mat-label>
        <input type="time" matInput placeholder="Start Time" formControlName="startTime">
      </mat-form-field>
      <mat-form-field mcColor="secondary" class="mc-form-field">
        <mat-label>Due Date</mat-label>
        <input matInput [matDatepicker]="duePicker" placeholder="Due Date" formControlName="dueDate">
        <mat-datepicker-toggle matIconSuffix [for]="duePicker"></mat-datepicker-toggle>
        <mat-datepicker color="secondary" #duePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field mcColor="secondary" class="mc-form-field">
        <mat-label>Due Time</mat-label>
        <input type="time" matInput placeholder="Due Time" formControlName="dueTime">
      </mat-form-field>
    </div>

    <mat-form-field mcColor="secondary" class="mc-form-field">
      <mat-label>Dates</mat-label>
      <mat-select placeholder="Dates" formControlName="dates" multiple>
        <mat-option class="mat-accent-vivid" [value]="FilterType.Overdue">Overdue</mat-option>
        <mat-option class="mat-accent-vivid" [value]="FilterType.Today">Today</mat-option>
        <mat-option class="mat-accent-vivid" [value]="FilterType.Tomorrow">Tomorrow</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field mcColor="secondary" class="mc-form-field">
      <mat-label>Users</mat-label>
      <mat-select placeholder="Users" formControlName="licenseUsers" multiple>
        <mat-option *ngFor="let licenseUser of licenseUsers$ | async" class="mat-accent-vivid" [value]="licenseUser.User.Id">{{licenseUser.User.FullName}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field mcColor="secondary" class="mc-form-field">
      <mat-label>Priorities</mat-label>
      <mat-select placeholder="Priorities" formControlName="priorities" panelClass="mc-task-filter-dialog-priority-dropdown" multiple>
        <mat-option class="mat-accent-vivid" [value]="TaskPriority.Low">
          <mat-icon color="task-low-priority" class="mc-task-calendar-priority-icon text-large" [fontSet]="'project-titan'" [fontIcon]="'icon-dot'"></mat-icon>
          Low Priority
        </mat-option>
        <mat-option class="mat-accent-vivid" [value]="TaskPriority.Medium">
          <mat-icon color="task-medium-priority" class="mc-task-calendar-priority-icon text-large" [fontSet]="'project-titan'" [fontIcon]="'icon-dot'"></mat-icon>
          Medium Priority
        </mat-option>
        <mat-option class="mat-accent-vivid" [value]="TaskPriority.High">
          <mat-icon color="task-high-priority" class="mc-task-calendar-priority-icon text-large" [fontSet]="'project-titan'" [fontIcon]="'icon-dot'"></mat-icon>
          High Priority
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field mcColor="secondary" class="mc-form-field">
      <mat-label>Projects</mat-label>
      <mat-select placeholder="Projects" formControlName="projects" multiple>
        <mat-option *ngFor="let project of projects$ | async" class="mat-accent-vivid" [value]="project.Id">{{project.Name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field mcColor="secondary" *ngIf="currentInfoKey === LicenseUserClientSideInfoKey.CalendarTaskPage" class="mc-form-field">
      <mat-label>Statuses</mat-label>
      <mat-select placeholder="Statuses" formControlName="statuses" multiple>
        <mat-option class="mat-accent-vivid" [value]="TaskStatus.Active">Active</mat-option>
        <mat-option class="mat-accent-vivid" [value]="TaskStatus.Backlog">Backlog</mat-option>
        <mat-option class="mat-accent-vivid" [value]="TaskStatus.Archive">Archive</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field mcColor="secondary" *ngIf="currentInfoKey === LicenseUserClientSideInfoKey.CalendarTaskPage" class="mc-form-field">
      <mat-label>Milestones</mat-label>
      <mat-select placeholder="Milestones" formControlName="milestones" multiple>
        <mat-option class="mat-accent-vivid" [value]="TaskMilestone.ToDo">To Do</mat-option>
        <mat-option class="mat-accent-vivid" [value]="TaskMilestone.InProgress">In Progress</mat-option>
        <mat-option class="mat-accent-vivid" [value]="TaskMilestone.Completed">Completed</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="mc-spring-board-form-footer">
    <div class="mc-form-buttons">
      <button type="submit" mat-raised-button color="primary">Save</button>
    </div>
  </div>
</form>